import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { GerinusService } from '../lib/gerinus.service';
import { Observable } from 'rxjs';

export interface IUpload {
    file: File,
    organization?: string
}

@Injectable()
export class UploadService extends GerinusService {
    constructor(public http: HttpClient) {
        super(http);
        this.model = 'AppModel';
    }

    upload({ file, organization }: IUpload) {
        const formData = new FormData();
        formData.append('file', file);

        const url = organization
            ? `${this.apiURL()}/api/app/file?organization=${encodeURIComponent(organization)}`
            : `${this.apiURL()}/api/app/file`;

        return this.http.post(url, formData, this.headers(true));
    }

    uploadWithProgress({ file, organization }: IUpload): Observable<HttpEvent<any>> {
        const formData = new FormData();
        formData.append('file', file);

        const url = organization
            ? `${this.apiURL()}/api/app/file?organization=${encodeURIComponent(organization)}`
            : `${this.apiURL()}/api/app/file`;

        return this.http.post(url, formData, {
            ...this.headers(true),
            reportProgress: true,
            observe: 'events',
        });
    }

    download(name: string, organization?: string) {
        return this.http.post(this.apiURL() + '/api/free/findAndDownloadFile/', { name, organization }, this.headers(true));
    }

    deleteFile(name: string, table: string, organization?: string): Observable<any> {
        let url = `${this.apiURL()}/api/app/delete-file?name=${encodeURIComponent(name)}&table=${encodeURIComponent(table)}`;
        if (organization) url += `&organization=${encodeURIComponent(organization)}`;

        return this.http.delete(url, this.headers());
    }

    downloadAndReturnArrayBuffer(url: string) {
        return this.http.get(url , { responseType: 'arraybuffer' });
    }
}
